import React, { useState, useEffect } from 'react';
import { Card, CardHeader, CardBody } from 'reactstrap';
import moment, { now } from 'moment';
import classNames from 'classnames';
import styles from './ContractInfo.module.css';
import BootstrapTable from 'react-bootstrap-table-next';
import { ReactComponent as DownloadIcon } from '../../assets/images/Download_Icon.svg';

let btnPrimary = 'btn-primary';
let fileClaim = styles.fileClaim;

export default function DocumentsInfo(props) {
    const [docLists, setDocLists] = useState([]);
    const [defaultSortedBy, setDefaultSortedBy] = useState([
        {
            dataField: 'createdDate',
            order: 'desc'
        }
    ]);

    const getDocLists = async () => {
        const url = `document/GetVendorDocumentsByContractId/${props.contract.contractId}/hvac`;

        try {
            const response = await fetch(url);
            const data = await response.json();
            setDocLists(data);
        } catch (error) {
            console.error('Error: ', error);
        }
    };

    const handleDocumentUrl = (val, docInfo) => {
        const isPdf = docInfo?.documentName.toLowerCase().indexOf('pdf') > -1 ? true : false;
        let file = '';
        let fileUrl = '';
        const byteCharacters = atob(docInfo?.documentData);
        const byteNumbers = Array.from(byteCharacters, (c) => c.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);

        if (isPdf) {
            file = new Blob([byteArray], { type: 'application/pdf' });
            fileUrl = URL.createObjectURL(file);
        } else {
            file = new Blob([byteArray], { type: 'image/png' });
            fileUrl = URL.createObjectURL(file);
        }
        return fileUrl;
    };

    useEffect(() => {
        getDocLists();
    }, []);

    const columns = [
        {
            dataField: 'createdDate',
            text: 'Date',
            formatter: (val, row) => {
                return props.contract.country.toLowerCase() === 'ca'
                    ? moment(val).format('DD/MM/YYYY hh:mm A')
                    : moment(val).format('MM/DD/YYYY hh:mm A');
            },
            headerFormatter: headerFormatter,
            style: widthFormatter('dateCol'),
            sort: true
        },
        {
            dataField: 'documentTypeName',
            text: 'Type of Document',
            formatter: (val, row) => {
                return (
                    <span
                        className={classNames('btn-link', styles.documentLink)}
                        onClick={() => props.handleDocumentModal(row, val)}
                    >
                        {val}
                    </span>
                );
            },
            headerFormatter: headerFormatter,
            style: widthFormatter('docCol'),
            sort: true
        },
        {
            dataField: 'fileSize',
            text: 'Size',
            style: widthFormatter('fileSizeCol'),
            headerFormatter: headerFormatter,
            sort: true
        },
        {
            dataField: '',
            text: '',
            formatter: (val, row) => {
                return (
                    <div className={styles.iconBtn}>
                        <DownloadIcon
                            id='downloadDocs'
                            onClick={() => window.open(handleDocumentUrl(val, row), '_blank')}
                        />
                    </div>
                );
            },
            style: widthFormatter('downloadCol')
        }
    ];

    function headerFormatter(column, index, { sortElement, filterElement }) {
        let { order } = sortElement.props;
        return (
            <span className={`${order === 'asc' ? styles.ascending : ''} ${order === 'desc' ? styles.descending : ''}`}>
                {column.text}
            </span>
        );
    }

    function widthFormatter(width) {
        const widths = {
            dateCol: '30%',
            docCol: '50%',
            fileSizeCol: '15%',
            downloadCol: '5%'
        };

        return {
            width: widths[width]
        };
    }

    return (
        <Card className={styles.documentContainer}>
            <CardHeader>
                <h1 className='h4'>Documents</h1>
            </CardHeader>

            <CardBody>
                <BootstrapTable
                    id='documentTable'
                    columns={columns}
                    data={docLists}
                    defaultSorted={defaultSortedBy}
                    keyField='createdDate'
                    bordered={false}
                />
            </CardBody>
        </Card>
    );
}
